import React, { useEffect } from "react";


import BannerSection from '../../shared/components/BannerSection/BannerSection';
import NavegationInfo from '../../shared/components/NavegationInfo/NavegationInfo';
import SectionInfo from '../../shared/components/SectionInfo/SectionInfo';
import SubscriptionPlan from "../../shared/components/SubscriptionPlan/SubscriptionPlan";


import priceBannerImg from '../../utils/assets/shared/bg1.png';
import profilesLockImg from '../../utils/assets/price/profiles-lock.png';
import onbgImg from '../../utils/assets/price/onbg1.png';
 



const Price = props => {

    useEffect(()=>{
        window.scroll(0,0);
       
    },[])

     const bannerSectionInfo =
     {
        cardTitle: "Cutting-edge technology to protect and secure your identity",
        cardButtonText: "Start Now",
        lengendBackground: priceBannerImg,
        cardImg : onbgImg
     }


    //  subscriptionTrialInfo: "Trial for 24 days at",
    //  subscriptionTrialPrice : "3.49",
     const subscriptionInformation = [
        {       
            subscriptionType: "MONTH",
            subscriptionPrice: "44.99",
            subscriptionTrialInfo: "Our product",
            subscriptionTrialPrice : "",
            subscriptionDescription: "Monthly",
            subscriptionButtonText: "Buy"
        }, 
        {
            
            title : "Join and start improving your privacy and digital security.",
            img: profilesLockImg,
            imgDescription: "profile-lock",
        }
    ]

    return ( 
        <React.Fragment>
             <BannerSection props={bannerSectionInfo}/>
             <NavegationInfo page="price"/>
             <SectionInfo title={"Purchase protection now"} color={'#fbb13b'} />
             <SubscriptionPlan props={subscriptionInformation}/>
        </React.Fragment>
    );            
};

export default Price;